import defaultProductImage from '@/assets/produit.png';

type ProductImageSource = {
  photo?: string | null;
  image?: string | null;
  image_url?: string | null;
  main_photo_url?: string | null;
  thumbnail_url?: string | null;
  product_photo?: string | null;
  product?: ProductImageSource | null;
};

export const DEFAULT_PRODUCT_IMAGE = defaultProductImage;

export function productImageUrl(source?: ProductImageSource | null): string {
  if (!source) {
    return defaultProductImage;
  }

  return source.photo
    || source.image
    || source.image_url
    || source.main_photo_url
    || source.thumbnail_url
    || source.product_photo
    || productImageUrl(source.product)
    || defaultProductImage;
}
